<template>
<div class="chapter">
<div class="inner_page">
<section class="element element-non-bodymatter element-container-single element-type-toc" epub:type="toc" id="table-of-contents" role="doc-toc">
<div class="toc-heading"><h1 class="toc-title">Contents</h1></div>
<div class="toc-contents text">
<div class="toc-frontmatter-group">
<div class="toc-item toc-item-entry-type-element toc-item-element-container-single has-no-leading-number has-no-author has-no-children">
<p class="item-title"><a href="#/anotefromthepublishers"><span class="item-title-text">A Note from the Publishers</span></a></p>
</div>
<div class="toc-item toc-item-entry-type-element toc-item-element-container-single has-no-leading-number has-no-author has-no-children">
<p class="item-title"><a href="#/iamtheworld"><span class="item-title-text">I Am the World</span></a></p>
</div>
</div>
<div class="toc-bodymatter-group">
<div class="toc-item toc-item-entry-type-chapter toc-item-element-container-single has-leading-number has-no-author has-no-children">
<p class="item-title"><span class="item-number">1. </span><a href="#/chapter001"><span class="item-title-text">Groundwork</span></a></p>
</div>
<div class="toc-item toc-item-entry-type-chapter toc-item-element-container-single has-leading-number has-no-author has-no-children">
<p class="item-title"><span class="item-number">2. </span><span href="#/chapter002" title="Link target outside of Sample"><span class="item-title-text">The Hundred-Year Party</span></span></p>
</div>
<div class="toc-item toc-item-entry-type-chapter toc-item-element-container-single has-leading-number has-no-author has-no-children">
<p class="item-title"><span class="item-number">3. </span><span href="#/chapter003" title="Link target outside of Sample"><span class="item-title-text">Nightmare Time</span></span></p>
</div>
<div class="toc-item toc-item-entry-type-chapter toc-item-element-container-single has-leading-number has-no-author has-no-children">
<p class="item-title"><span class="item-number">4. </span><span href="#/chapter004" title="Link target outside of Sample"><span class="item-title-text">Bad Medicine</span></span></p>
</div>
<div class="toc-item toc-item-entry-type-chapter toc-item-element-container-single has-leading-number has-no-author has-no-children">
<p class="item-title"><span class="item-number">5. </span><span href="#/chapter005" title="Link target outside of Sample"><span class="item-title-text">Drying Out</span></span></p>
</div>
<div class="toc-item toc-item-entry-type-chapter toc-item-element-container-single has-leading-number has-no-author has-no-children">
<p class="item-title"><span class="item-number">6. </span><span href="#/chapter006" title="Link target outside of Sample"><span class="item-title-text">Recovery</span></span></p>
</div>
<div class="toc-item toc-item-entry-type-chapter toc-item-element-container-single has-leading-number has-no-author has-no-children">
<p class="item-title"><span class="item-number">7. </span><span href="#/chapter007" title="Link target outside of Sample"><span class="item-title-text">Release</span></span></p>
</div>
</div>
<div class="toc-backmatter-group">
<div class="toc-item toc-item-entry-type-element toc-item-element-container-single has-no-leading-number has-no-author has-no-children">
<p class="item-title"><span href="#/abouttheauthor" title="Link target outside of Sample"><span class="item-title-text">About the Author</span></span></p>
</div>
<div class="toc-item toc-item-entry-type-element toc-item-element-container-single has-no-leading-number has-no-author has-no-children">
<p class="item-title"><span href="#/ifyouliked" title="Link target outside of Sample"><span class="item-title-text">If You Liked …</span></span></p>
</div>
<div class="toc-item toc-item-entry-type-element toc-item-element-container-single has-no-leading-number has-no-author has-no-children">
<p class="item-title"><span href="#/otherwordfirepresstitles" title="Link target outside of Sample"><span class="item-title-text">Other WordFire Press Titles</span></span></p>
</div>
</div>
</div>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// contents.vue?08b3f11c